<template>
  <div style=" flex:1; display:flex; flex-direction:row; ">
    <div style="width:200px">
      <el-form>
        <el-form-item :label="$t('duck.sensor')">
          <el-select v-model="selectedSensor" @change="onSelectSensorChange">
            <el-option v-for="item in sensors" :label="item.label" :key="item.key" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('duck.channel')">
          <el-select v-model="selectedChannel" @change="setRawData">
            <el-option v-for="item in channels" :label="item.label" :key="item.key" :value="item.value"
              :disabled="item.disabled"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

    </div>
    <div style="flex:1; display:flex">
     <ChartEnvelope v-if="rawData.length"  
      :rawData="rawData"
      :sensor="activeSensor"
     :bearing="

                        measurement &&
                        measurement.point &&
                        measurement.point.bearing
                      " :referenceFrequency="Number(rpm / 60)" :samplingRate="
  measurement ? measurement.calibratedSamplingRate : 100
"></ChartEnvelope>
      </div>
  </div>
</template>

<script>
import dayjs from 'dayjs-ext';
import preferences from "../util/preferences";
import ChartEnvelope  from './Chart_Envelope';
// import dsp from '../../util/dsp'
export default {
  name: "measurement--duck-details-spectrum",
  components: {
    ChartEnvelope
  },
  props: {
    measurement: {
      type: Object,
      required: true,
      default: () => ({})
    },
  },
  data() {
    return {
      rpm: 0,
      mode: "spectrum",
      selectedSensor: "",
      selectedChannel: "",
      rawData:[]
    };

  },
  created() {
    console.log(this.measurement);

    this.load();

  },
  computed: {
    channels() {
      if (!this.measurement || this.selectedSensor == "") {
        return [];
      }
      console.log(this.selectedSensor);
      return this.measurement.config.sensors.find(x => x.groupCode === this.selectedSensor)
        .channels.map(c => {
          return {
            label: this.$t(`duck.${c.channel}`),
            value: `channel_${c.order}`,
            key: c.order,
            disabled: !this.measurement.measurementData.some(x => x.key === `channel_${c.order}`)
          };
        });
    },
    sensors() {
      if (!this.measurement) {
        return [];
      }

      return this.measurement.config.sensors.filter(s => {
        return s.channels.some(c => this.measurement.measurementData.some(d => d.key == `channel_${c.order}`));
      }).map(s => {
        return {
          label: s.displayName,
          value: s.groupCode,
          key: s.groupCode
        };
      });
    },
    activeSensor(){
 if (!this.measurement) {
        return ""
      }

        return this.measurement.config.sensors.find(x => x.groupCode === this.selectedSensor).name
    },
  },
  watch: {
    "measurement": function (val) {
      if (val) {
        this.load();
      }
    },
  },
  methods: {
       onSelectSensorChange() {
      let selectedSensor = this.measurement.config.sensors.find(x => x.groupCode === this.selectedSensor);
      if (selectedSensor.channels.length > 0) {
        this.selectedChannel = `channel_${selectedSensor.channels[0].order}`;
        this.setRawData();
      }
    },
    setRawData(){
      if(this.selectedChannel && this.selectedSensor ){
        this.rawData = this.measurement.data[this.selectedChannel];
      }
    },
    dateDate(date) {
      return dayjs(date).format(preferences().localization.dateFormat);
    },
    load() {
      let rpmTelemetry = this.measurement.telemetry.find(x => x.name == "RPM");
      if (rpmTelemetry) {
        this.rpm = rpmTelemetry.value;
      } else {

        this.rpm = this.measurement.point ? ((this.measurement.point.referenceFrequency * 60) || 0) : 0;
      }
       if (this.measurement.config.sensors.length > 0) {
        this.selectedSensor = this.measurement.config.sensors[0].groupCode;
        this.onSelectSensorChange();
      }
    },

  },
};
</script>
<style scoped>
</style>
<style>
#chart-line{
width:100%;
}</style>